import { defineStore } from 'pinia'

export const useGmoPageStore = defineStore('gmoPageStore', {
  state: () => ({
    gmoPage: null,
    gmoUrl: null
  })
})
